<template>
  <v-card :to="'/dashboard/' + controller.controllerId" :color="(controller.online != '1') ? 'inactive' : ''" class="br-3 py-5">
    <v-card-actions class="pb-2 pl-5 pr-4">
      <div class="title">{{ controller.displayName }}</div>
      <div class="flex-grow-1"></div>
      <v-badge overlap color="primary" class="mr-2" v-if="controllerNotifications(controller.controllerId) > 0">
        <template v-slot:badge>{{ controllerNotifications(controller.controllerId) }}</template>
        <v-icon>mdi-bell-ring-outline</v-icon>
      </v-badge>
    </v-card-actions>
    <v-card-text class="pt-0 pb-2 px-5">
      <v-row no-gutters style="flex-wrap: nowrap;">
        <v-col
          cols="1"
          style="min-width: 100px; max-width: 100%; padding-top: 7px;"
          class="flex-grow-1 flex-shrink-0"
        >
          <v-progress-linear :value="showProgress" height="16" rounded color="accent"></v-progress-linear>
        </v-col>
        <v-col
          cols="3"
          style="min-width: 95px;"
          class="flex-grow-0 flex-shrink-1 text-right"
        >
          <span class="font-weight-black headline">{{ controller.boilerTemp | dotToComma }}&deg;C</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    show: false,
    loaded: false
  }),
  props: ['controller'],
  computed: {
    controllerNotifications() {
      return controllerId => this.$store.getters['notifications/countByController'](controllerId)
    },
    progress() {
      if (parseInt(this.controller.boilerTemp) < 35) {
        return 0;
      } else if (parseInt(this.controller.boilerTemp) > 80) {
        return 100;
      } else {
        return ((parseInt(this.controller.boilerTemp) - 35) / (80 - 35)) * 100;
      }
    },
    showProgress() {
      return (this.loaded) ? this.progress : 0;
    }
  },
  filters: {
    dotToComma(val) {
      return val.toString().replace('.', ',')
    }
  },
  mounted () {
    setTimeout(() => { this.loaded = true; }, 200);
  },
  methods: {
    gotoDash () {
      this.$router.push({ path: '/dashboard/' + this.controller.controllerId });
    }
  }
}
</script>

<style>
.theme--light.v-card.inactive:not(.v-card--flat) {
  background-color: #f3f4fa;
}
.theme--dark.v-card.inactive:not(.v-card--flat) {
  opacity: 0.5
}
.v-input.dummy .v-messages {
  display: none;
}
</style>